import { Suspense, lazy, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth';
import { RequireAuth } from '@/components/RequireAuth';
import { RootLayout } from '@/components/layout/RootLayout';
import { LoadingScreen } from '@/components/LoadingScreen';

// 코드 스플리팅 — 페이지별 청크 분리
const Landing = lazy(() => import('@/pages/Landing'));
const Templates = lazy(() => import('@/pages/Templates'));
const Login = lazy(() => import('@/pages/Login'));
const Editor = lazy(() => import('@/pages/Editor'));
const MyAccount = lazy(() => import('@/pages/MyAccount'));
const Invitation = lazy(() => import('@/pages/Invitation'));
const Expired = lazy(() => import('@/pages/Expired'));
const NotFound = lazy(() => import('@/pages/NotFound'));
const Privacy = lazy(() => import('@/pages/Privacy'));
const Manage = lazy(() => import('@/pages/Manage'));

export default function App() {
  const initAuthListener = useAuthStore((s) => s.initAuthListener);

  useEffect(() => {
    // 앱 부팅 시 Firebase Auth 상태 구독 시작 (구독 해제는 페이지 사용 종료 시 자동)
    const unsub = initAuthListener();
    return () => unsub?.();
  }, [initAuthListener]);

  return (
    <Suspense fallback={<LoadingScreen />}>
      <Routes>
        {/* 공유용 청첩장 라우트는 SSR Function이 우선 처리하지만, 클라이언트 폴백도 보유 */}
        <Route path="/i/:slug" element={<Invitation />} />
        <Route path="/i/:slug/expired" element={<Expired />} />

        {/* 의뢰자 관리 패널 — Firebase 로그인 불필요, 비밀번호 검증 */}
        <Route path="/manage/:slug" element={<Manage />} />

        {/* 일반 사이트 레이아웃 */}
        <Route element={<RootLayout />}>
          <Route index element={<Landing />} />
          <Route path="/templates" element={<Templates />} />
          <Route path="/login" element={<Login />} />
          <Route path="/privacy" element={<Privacy />} />

          <Route
            path="/editor/:id"
            element={
              <RequireAuth>
                <Editor />
              </RequireAuth>
            }
          />
          <Route
            path="/my"
            element={
              <RequireAuth>
                <MyAccount />
              </RequireAuth>
            }
          />

          <Route path="/404" element={<NotFound />} />
          <Route path="*" element={<Navigate to="/404" replace />} />
        </Route>
      </Routes>
    </Suspense>
  );
}
